import { createGetDataReducer } from "./CommonReducer";
import { ATTRIBSLIST , ATTRIBSCREATE , ATTRIBSDETAILS , ATTRIBSSTATUS ,ATTRIBSUPDATE } from "../../Constants/AttribsConstants";

export const AtributeGetReducer = createGetDataReducer( ATTRIBSLIST );
export const AtributeCreateReducer = createGetDataReducer( ATTRIBSCREATE );
export const AtributeStatusReducer = createGetDataReducer( ATTRIBSSTATUS );
export const AtributeUpdateReducer = createGetDataReducer( ATTRIBSUPDATE );
export const AtributeDetailsReducer = createGetDataReducer( ATTRIBSDETAILS );
